import futura from '../assets/futura.png'
import { useState, useEffect } from 'react';
import Select from 'react-select'
import SimpleReactValidator from 'simple-react-validator';
import close from '../assets/close.png'
import arrow from '../assets/arrow2.png'
function N4({ bookid, nextPage,  previuosPage, home }) {
    const [city, setCity] = useState([])
    const [SELEZIONATO, setSEL] = useState("nulla")
    const [address, setAddress] = useState()
    const [name, setName] = useState()
    const [desc, setDesc] = useState()
    const validator = new SimpleReactValidator({ autoForceUpdate: this });

    const [vai, setVai] = useState(false)
    const getCity = () => {
        fetch(document.apiURL + '/city', {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setCity(response.map(r => { return { "value": r.id, "label": r.city } }))
            });
    }

    const checkData = () => {
        if (validator.fieldValid('city') && validator.fieldValid('address') && validator.fieldValid('desc') && validator.fieldValid('name')) {
            editBook()
        }
    }

    const editBook = () => {
        fetch(document.apiURL + '/book/' + bookid, {
            method: 'PUT',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "cityID": SELEZIONATO,
                "address": address,
                "dorbell_name": name,
                "address_note": desc,

            })

        })
            .then(response => response.json())
            .then(response => {
                if (response) {
                    nextPage()
                    //window.location = '/book/5/' + bookid
                } else {
                    alert("aglia")
                }

            });
    }


    useEffect(() => {
        getCity();
        setSEL(parseInt(localStorage.getItem('city'))) 
        
    }, [SELEZIONATO]);
    return (<>
        <div className="back-profilazione">
            <div className="square-center">
            <div className="flex row sp" style={{ borderRadius: '16px 16px 0px 0px' }}>

<img src={arrow} onClick={()=> previuosPage()} /> 
<img src={close} onClick={()=> home()} />  

</div>
                <div className="flex row center-con sp">
                    <h2 className="c">Dove hai bisogno dell’intervento?</h2><img src={futura} className="min-fut">
                    </img>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Indirizzo del paziente:</h4>
                        <input onChange={(e) => { setAddress(e.target.value) }} type="text" className="input" style={{ width: '100%' }} placeholder="Indirizzo"></input>
                        {validator.message('address', address, 'required|alpha_num_space')}
                        {vai === false ? null : <p style={{color:'red'}}>{validator.fieldValid('address') === true ? null : 'Assicurati di aver inserito il campo'}</p>}

                        <input onChange={(e) => { setName(e.target.value) }} type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Nome al citofono"></input>
                        {validator.message('name', name, 'required|alpha_num_space')}
                        {vai === false ? null : <p style={{color:'red'}}>{validator.fieldValid('name') === true ? null : 'Assicurati di aver inserito il campo'}</p>}

                        <Select className="react-input-full" value={city.filter(t => t.value == SELEZIONATO ? t.value : null)} onChange={(e) => setSEL(e.value)} placeholder={SELEZIONATO ? city.filter(t => t.value == SELEZIONATO ? t.label : null) : 'seleziona città'} options={city} />
                        {validator.message('city', SELEZIONATO, 'required|numeric')}
                        {vai === false ? null : <p style={{color:'red'}}>{validator.fieldValid('city') === true ? null : 'Assicurati di aver inserito il campo'}</p>}
                        <input onChange={(e) => { setDesc(e.target.value) }} type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Descrizione abitazione (scala, piano..)"></input>
                        {validator.message('desc', desc, 'required|alpha_num_space')}
                        {vai === false ? null : <p style={{color:'red'}}>{validator.fieldValid('desc') === true ? null : 'Assicurati di aver inserito il campo'}</p>}
                    </div>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <button onClick={() => { setVai(true); checkData() }} className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Continua</button>
                        <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>
                    </div>
                </div>




            </div>
        </div>
    </>
    );
}

export default N4;